import { CardGridPage } from '@/components/CardGridPage';

export default function ServicesPage() {
  return (
    <div className="min-h-screen">
      <CardGridPage
        folderSlug="services"
        title="Services"
        intro={`I build three things — and they work together.

**Strategic Clarity** — Cut through complexity to find the one decision that changes everything.
**Implementation Infrastructure** — Live systems that outlast the consulting engagement.
**AI Knowledge Systems** — Your expertise, structured into a platform your team actually uses.

Every engagement starts with understanding what you are at your best — not what the market says you should be.

[Watch: The Central Question →](/services/the-central-question)`}
        heroImage="/images/carla-services.webp"
        heroImageAlt="Carla Taylor — Strategic Consulting"
      />
    </div>
  );
}
